import axios from 'axios'
import {ApiUrl, geoJsonKey} from './settings'

const AuthAxios = axios.create({
    baseURL: ApiUrl,
})

const AddressApi = axios.create({
    // baseURL: 'https://api.addressy.com'
    baseURL: 'https://services.postcodeanywhere.co.uk',
})

let getToken = () => {
    return ({'headers': {'Authorization': 'Bearer ' + localStorage.getItem('token')}})
}

class Request {

    error = (err) => {
        try {
            if (err.response.status === 401) {
                localStorage.clear()
            }
        } catch (e) {
        }
    }

    //region Auth

    login(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/loginWithPassword', data)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    registerUser(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/register', data)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    logout() {
        return new Promise((next, error) => {
            AuthAxios
                .post('/logout', {}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    checkEmailExists(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/checkEmailExist', data)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    checkCouponExists(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/checkCouponExists', data)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    resetCustomerPassword(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/resetCustomerPassword', data)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    //endregion

    //region category

    getCategory(data) {
        return new Promise((next, error) => {
            AuthAxios.post('/api/getCategoryProductNew', {...data}).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    getCategoryWithSubCategory(data) {
        return new Promise((next, error) => {
            AuthAxios.post('/api/getCategoryWithSubCategory', {...data}).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    getCategoryTrimList(data) {
        return new Promise((next, error) => {
            AuthAxios.get('/category', {params: {...data}}).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }


    searchProduct(data) {
        return new Promise((next, error) => {
            AuthAxios.post('/api/searchProduct', {...data}).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    //endregion

    //region slot api

    getSingleSlot() {
        return new Promise((next, error) => {
            AuthAxios.post('/getSingleSlot').then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    //endregion

    //region Geo Code Api

    checkValidPinCode(data) {
        return new Promise((next) => {
            axios.get(`https://api.postcodes.io/postcodes/${data.text}`)
                .then((result) => {
                    next(result)
                }, (err) => {
                    next('err')
                })
        })
    }

    getGeoJsonByText(data) {
        return new Promise((next) => {
            // console.log(`/Capture/Interactive/Find/v1.00/json3ex.ws?Key=${geoJsonKey}&Text=${data.text}&Container=&Origin=&Countries=GB&Datasets=&Limit=7&Filter=&Language=en&$block=true&$cache=true&SOURCE=PCA-SCRIPT&SESSION=b0429722-3880-b13f-e22e-531344a0346f`);
            AddressApi.get(
                `/Capture/Interactive/Find/v1.00/json3ex.ws?Key=${geoJsonKey}&Text=${data.text}&Container=&Origin=&Countries=GB&Datasets=&Limit=7&Filter=&Language=en&$block=true&$cache=true&SOURCE=PCA-SCRIPT&SESSION=b0429722-3880-b13f-e22e-531344a0346f`)
                .then(
                    (result) => {
                        next(result)
                    },
                    (error) => {
                        next([])
                    },
                )
        })
    }

    getGeoJsonByPostCode(data) {
        return new Promise((next) => {
            AddressApi.get(
                `/Capture/Interactive/Find/v1.00/json3ex.ws?Key=${geoJsonKey}&Text=${data.text}&Container=${data.id}&Origin=&Countries=GB&Datasets=&Limit=7&Filter=&Language=en&$block=true&$cache=true&SOURCE=PCA-SCRIPT&SESSION=b0429722-3880-b13f-e22e-531344a0346f`)
                .then(
                    (result) => {
                        next(result)
                    },
                    (error) => {
                        next([])
                    },
                )
        })
    }

    getGeoJsonAddressFullInfo(data) {
        return new Promise((next) => {
            AddressApi.get(
                `/Capture/Interactive/Retrieve/v1.00/json3ex.ws?Key=${geoJsonKey}&Id=${data.id}&Source=&$cache=true`)
                .then(
                    (result) => {
                        next(result)
                    },
                    (error) => {
                        next([])
                    },
                )
        })
    }

    getSlotByPostalCode(data) {
        return new Promise((next, error) => {
            AuthAxios.post('/getSlotByPostalCode', data).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    getSingleSlotTemp(data) {
        return new Promise((next, error) => {
            AuthAxios.post('/getSingleSlotTemp', data).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    //endregion

    //region Order

    checkOut(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/order', data)
                .then((d) => {
                    console.log(d.data)
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    applyPromoCode(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/checkAndApplyPromoCode', data)
                .then((d) => {
                     console.log(d.data);
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getCustomerOrders(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/customer/orders', {...data}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getCustomerActiveOrders(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/customer/active-orders', {...data}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    placeOrder(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/placeOrder', {...data}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    deleteOrder(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/api/deleteOrder', {...data}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    //endregion

    //region Order Session

    createSession(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/api/createOrderSession', {...data})
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getSession(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/api/getOrderSession', {...data})
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getSingleOrder(data) {
        return new Promise((next, error) => {
            AuthAxios.post(`/orderForInfo/${data.orderId}`, {}).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    //endregion

    //region User

    getUser(data) {
        return new Promise((next, error) => {
            if (data && data._id) {
                AuthAxios
                    .get(`/user/${data._id}`, {params: {...data}, ...getToken()})
                    .then((d) => {
                        next(d.data)
                    })
                    .catch((err) => {
                        next({error: true, err})
                        this.error(err)
                    })
            } else {
                next({error: true})
            }
        })
    }

    getCustomerPaymentMethod() {
        return new Promise((next, error) => {
            AuthAxios
                .post(`/customerPaymentMethod`, {}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    updateCustomer(data) {
        return new Promise((next, error) => {
            AuthAxios
                .put('/user', {...data}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    updatePaymentMethod(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/updatePaymentMethod', {...data}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    updateCustomerPassword(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/updateCustomerPassword', {...data}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    updateUserExtraFields(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/updateUserExtraFields', {...data}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    updateAlertSetting() {
        return new Promise((next, error) => {
            AuthAxios
                .post('/updateAlertSetting', {}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    //endregion

    // region Subscription

    getAllSubscriptionPack(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/allSubscriptionPack', data)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    subscribePackage(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/subscribePackage', data)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    updateSubscribePackage(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/updateSubscribePackage', data, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getUserSubscription() {
        return new Promise((next, error) => {
            AuthAxios
                .post('/getUserSubscriptionPlan', {}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getUserRegularPickup(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/getUserRegularPickup', data, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    addRegularPickup(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/addRegularPickup', data, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    deleteRegularPickup(data) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/deleteRepeatPickup', data, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    //endregion

    //region LocalStorage

    setLocationStorage(type, data) {
        return new Promise((next, error) => {
            localStorage.setItem(type, JSON.stringify(data))
            next('done')
        })
    }

    getLocationStorage(type) {
        return new Promise((next, error) => {
            let data = localStorage.getItem(type) ? JSON.parse(localStorage.getItem(type)) : null
            next(data)
        })
    }

    //endregion

    //region Extra

    getSingleGlobalNote() {
        return new Promise((next) => {
            AuthAxios
                .post('/getSingleGlobalNote', {}, getToken())
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    submitServing(data) {
        return new Promise((next, error) => {
            AuthAxios.post('/submitServing', data).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    submitEnquiry(data) {
        return new Promise((next, error) => {
            AuthAxios.post('/addEnquiry', data).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    //endregion


    //region Leads

    submitLeads(data) {
        return new Promise((next, error) => {
            AuthAxios.post('/leads', data).then((d) => {
                next(d.data)
            }).catch((err) => {
                next({success: false, err})
            })
        })
    }

    //endregion

    getAllWpCategory(data) {
        return new Promise((next, error) => {
            AuthAxios
                .get('/wpCategory', data)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getAllPosts(data) {
        return new Promise((next, error) => {
            AuthAxios
                .get('/wpPosts', {params: {...data}})
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getServicePage(data) {
        return new Promise((next, error) => {
            AuthAxios
                .get('/wpServices', {params: {...data}})
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getServiceSlugInfo(slug) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/getServiceSlugInfo', {slug})
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getPriceGuaranted() {
        return new Promise((next, error) => {
            AuthAxios
                .post('/getPriceGuaranted')
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getHomeFaq() {
        return new Promise((next, error) => {
            AuthAxios
                .post('/getHomeFaq')
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getPage(slug) {
        return new Promise((next, error) => {
            AuthAxios
                .post('/getPage', {slug})
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    console.log(err)
                    next({error: true, err})
                    this.error(err)
                })

        })
    }


    getPost(id) {
        return new Promise((next, error) => {
            AuthAxios
                .get(`/wpPosts/${id}`)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getTestimonials() {
        return new Promise((next, error) => {
            AuthAxios
                .post(`/getTestimonials`)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }


    getPartnerLogos() {
        return new Promise((next, error) => {
            AuthAxios
                .post(`/getPartnerLogos`)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getAboutPosts() {
        return new Promise((next, error) => {
            AuthAxios
                .post(`/getAboutPosts`)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getHomePage() {
        return new Promise((next, error) => {
            AuthAxios
                .post(`/getHomePage`)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getLaundryNearMe() {
        return new Promise((next, error) => {
            AuthAxios
                .post(`/getLaundryNearMe`)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }

    getSaveWithOurSubscription() {
        return new Promise((next, error) => {
            AuthAxios
                .post(`/getSaveWithOurSubscription`)
                .then((d) => {
                    next(d.data)
                })
                .catch((err) => {
                    next({error: true, err})
                    this.error(err)
                })

        })
    }
}

export default new Request

